<div class="overlay animated fadeIn" *ngIf="ShowEmailNotificationContainer || TaskStatusChangeMessageContainer || DeleteCommentContainer || ShowFinalCommentAddingContainer || this.parent.loading;"></div>

<div class="InfoQuestion animated fadeInDown" *ngIf="DeleteCommentContainer">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="DeleteCommentContainer = false; DeletingCommentID = null;CurrentComment = null;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'Configuration.DeleteQuestion' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'Configuration.DeleteQuestionDescription' | translate }}
    </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="DeleteCommentContainer = false; DeletingCommentID = null;CurrentComment = null;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="DeleteCommentContainer = false;DeleteComment(DeletingCommentID);">{{ 'Configuration.DeleteYesButton' | translate }}</button>
    </div>
</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="TaskStatusChangeMessageContainer">
  <div class="InfoQuestionClose">
    <i class="material-icons" (click)="TaskStatusChangeMessageContainer = false; DeletingCommentID = null;CurrentComment = null;">close</i>
  </div>
  <div class="InfoQuestionTitle">
    {{ 'StatusChangeUpdate' | translate }}
  </div>
  <div class="InfoQuestionBody">
    {{TaskStatusChangeResponse.Message}}
  </div>

  <div class="InfoQuestionCommands">
    <button [disabled]="this.parent.loading" style="background: #020044;color: #fff;" mat-raised-button color="primary" class="InfoQuestionButton" (click)="TaskStatusChangeMessageContainer = false;">{{ 'OK' | translate }}</button>
  </div>
</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowFinalCommentAddingContainer">
  <div class="InfoQuestionClose">
    <i class="material-icons" (click)="ShowFinalCommentAddingContainer = false;">close</i>
  </div>
  <div class="InfoQuestionTitle">
    {{ 'AddCompletingComment' | translate }}
  </div>
  <div class="InfoQuestionBody">
    {{ 'AddCompletingCommentDesc' | translate }}

    <mat-form-field appearance="outline" class="fullWidth" *ngIf="this.Comment != null;">
      <mat-label>{{ 'NewComment' | translate }}</mat-label>
      <textarea [disabled]="this.Locked ? true : null" autocomplete="off" matInput
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="5"
                cdkAutosizeMaxRows="5"
                [(ngModel)]="this.Comment.Comment"></textarea>
      </mat-form-field>
  </div>

  <div class="InfoQuestionCommands">
    <button [disabled]="this.parent.loading" style="background: #020044;color: #fff;" mat-raised-button class="InfoQuestionButton" (click)="ShowFinalCommentAddingContainer = false;AddNewCommentary();UpdateInternalTask();ViewTask(this.Task.ID);">
      <i class="material-icons">add</i>
      {{ 'AddComment' | translate }}
    </button>
    <button style="background: #f60;" [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowFinalCommentAddingContainer = false;UpdateInternalTask();ViewTask(this.Task.ID);">
      <i class="material-icons">warning_amber</i>
      {{ 'JumpOver' | translate }}
    </button>
  </div>
</div>

<div class="EmailNotificationContainer animated fadeInDown" *ngIf="ShowEmailNotificationContainer">
  <div class="InfoQuestionClose">
    <i class="material-icons" (click)="ShowEmailNotificationContainer = false;">close</i>
  </div>
  <div class="InfoQuestionTitle">
    {{ 'SendEmailNotification' | translate }}
  </div>
  <div class="EmailNotificationBody">
    <p class="EmailNotificationBodyTitle">{{ 'SendEmailNotificationDesc' | translate }}</p>

    <mat-form-field style="width: 100%;" appearance="outline">
      <mat-label>{{ 'ServerConfiguration' | translate }}</mat-label>
      <mat-select name="SMTPConfigs" [compareWith]="this.parent.compareFn" [(ngModel)]="CurrentSMTP">
        <mat-option *ngFor="let s of this.SMTPConfigs" [value]="s">
          {{s.SMTPServer}} (Port: {{s.Port}})
        </mat-option>
      </mat-select>
    </mat-form-field>

    <p class="EmailNotificationBodyTitle">{{ 'SendingEmail' | translate }}:</p>

    <div class="SMTPEmailContainer" *ngFor="let e of this.SMTPEmails" (click)="SelectSMTPEmail(e);">
      <span>{{e.Email}}</span>
      <i class="material-icons" *ngIf="e.IsDefault == true;">radio_button_checked</i>
      <i class="material-icons" *ngIf="e.IsDefault == false;" style="color: #000;">radio_button_off</i>
    </div>

    <mat-form-field class="fullWidth EmailSubject" appearance="outline" style="margin-top: 20px;">
      <mat-label>{{ 'Subject' | translate }}</mat-label>
      <input autocomplete="off" [(ngModel)]="this.EmailSubject" matInput>
    </mat-form-field>

    <mat-form-field appearance="outline" class="fullWidth">
      <mat-label>{{ 'YourMessage' | translate }}</mat-label>
      <textarea autocomplete="off" matInput
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="5"
                cdkAutosizeMaxRows="5"
                [(ngModel)]="this.EmailNotificationMessage"></textarea>
    </mat-form-field>

      <p class="EmailNotificationBodyTitle">{{ 'Recipients' | translate }}:</p>
      <span class="AsigneeSpan" *ngFor="let a of this.PrefferedAssignees" (click)="RemoveUserFromMessage(a);">
        <i class="material-icons">close</i>
        {{a.UIName}}
      </span>
  </div>

  <div class="InfoQuestionCommands" style="margin-top: 25px;">
    <button [disabled]="this.parent.loading" style="background: #0082e6;color: #fff;" mat-raised-button class="InfoQuestionButton" (click)="ShowEmailNotificationContainer = false;SendInternalTaskEmailNotification();">
      <i class="material-icons">email</i>
      <i class="material-icons">double_arrow</i>
      {{ 'SendEmailNotification' | translate }}
    </button>
    <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowEmailNotificationContainer = false;">
      <i class="material-icons">close</i>
      {{ 'Cancel' | translate }}
    </button>
  </div>
</div>

<div class="PageContent">
  <div class="PageContentTitle" *ngIf="this.Task?.ID != null;">
    <i class="material-icons" style="color:#32aa3a;">verified_user</i>
    {{'InternalTask' | translate}} [ {{this.Task.ID}} ] {{'from' | translate}} {{this.Task.EventRegisterUI}}

    <div class="TaskLockIcon" *ngIf="this.parent.User.Id == this.Task.Owner.Id;">
      <i class="material-icons" (click)="this.Task.Locked = !this.Task.Locked; this.LockInternalTask();" *ngIf="this.Task.Locked == false;" matTooltip="{{ 'TaskLockDescription' | translate }}" matTooltipClass='neutral-tool-tip-management'>lock_open</i>
      <i class="material-icons" (click)="this.Task.Locked = !this.Task.Locked; this.LockInternalTask();" *ngIf="this.Task.Locked == true;" matTooltip="{{ 'TaskLockDescription' | translate }}" matTooltipClass='neutral-tool-tip-management'>lock_outline</i>
    </div>

    <div class="TaskLockIcon" *ngIf="this.Locked == true || this.parent.User.Id != this.Task.Owner.Id;">
      <i style="cursor:not-allowed;" class="material-icons" *ngIf="this.Task.Locked == true;" matTooltip="{{ 'TaskLockDescription' | translate }}" matTooltipClass='neutral-tool-tip-management'>lock_outline</i>
      <i style="cursor:not-allowed;" class="material-icons" *ngIf="this.Task.Locked == false;" matTooltip="{{ 'TaskLockDescription' | translate }}" matTooltipClass='neutral-tool-tip-management'>lock_open</i>
    </div>

    <div class="TaskStatusLabel" [ngClass]="{'TaskStandardStatus': this.Task.Severity.ID == 0, 'TaskUrgentStatus': this.Task.Severity.ID == 1, 'TaskCriticalStatus': this.Task.Severity.ID == 2 }">
      {{'TaskSeverity' | translate}}: {{this.Task.Severity.Name}}
    </div>

    <div class="TaskStatusLabel" [ngClass]="{'TaskProgressStatus': this.Task.Status.ID == -1, 'TaskWorkingStatus': this.Task.Status.ID == 0, 'TaskCompleteStatus': this.Task.Status.ID == 1 }">
      {{this.Task.Status.Name}}
    </div>

    <div class="TaskStatusLabel TaskWorkingStatus" style="cursor: pointer;" (click)="OpenSendEmailNotificationContainer();">
      <i class="material-icons">email</i>
      {{'SendEmailNotification' | translate}}
    </div>
  </div>
  <div class="PageContentTitle" *ngIf="this.Task?.ID == null;">
        <i class="material-icons">add</i>
        <i class="material-icons">work_outline</i>
        <i class="material-icons">schedule</i>
        {{'NewTask' | translate}}

        <div class="TaskLockIcon">
          <i class="material-icons" (click)="this.Task.Locked = !this.Task.Locked;" *ngIf="this.Task.Locked == false;" matTooltip="{{ 'TaskLockDescription' | translate }}" matTooltipClass='neutral-tool-tip-management'>lock_open</i>
          <i class="material-icons" (click)="this.Task.Locked = !this.Task.Locked;" *ngIf="this.Task.Locked == true;" matTooltip="{{ 'TaskLockDescription' | translate }}" matTooltipClass='neutral-tool-tip-management'>lock_outline</i>
        </div>

        <div class="TaskStatusLabel" [ngClass]="{'TaskStandardStatus': this.Task?.Severity?.ID == 0, 'TaskUrgentStatus': this.Task?.Severity?.ID == 1, 'TaskCriticalStatus': this.Task?.Severity?.ID == 2 }">
          {{'TaskSeverity' | translate}}: {{this.Task?.Severity?.Name}}
        </div>
    
        <div class="TaskStatusLabel" [ngClass]="{'TaskProgressStatus': this.Task?.Status?.ID == -1, 'TaskWorkingStatus': this.Task?.Status?.ID == 0, 'TaskCompleteStatus': this.Task?.Status?.ID == 1 }">
          {{this.Task?.Status?.Name}}
        </div>

        <div class="TaskStatusLabel TaskWorkingStatus" style="cursor: pointer;" (click)="OpenSendEmailNotificationContainer();">
          <i class="material-icons">email</i>
          {{'SendEmailNotification' | translate}}
        </div>
  </div>
    <div class="PageContentBody animated fadeIn" *ngIf="this.InitialLoading != true;">
        <div class="OneThirdColumn" style="padding-left: 30px;">
            <div class="ColumnTitle" style="text-transform:capitalize;color: #0082e6;">
              <span class="ColumnTitleFancySpan">
                <i class="material-icons">account_circle</i>
                {{'InitialCreator' | translate}} ({{'Owner' | translate}}): {{this.Task?.Owner?.UIName}}
              </span>
            </div>
            <div class="ColumnTitle" style="text-transform:capitalize;color: #32aa3a;">
               <span class="ColumnTitleFancySpan">
                <i class="material-icons">work</i>
                {{'Company' | translate}}: {{this.Task?.Company?.Name}}
               </span>
            </div>

            <div class="ColumnTitle" style="text-transform:capitalize;">
               <span class="ColumnTitleFancySpan">
                <i class="material-icons">supervisor_account</i>
                {{'AsignTaskToSomeone' | translate}}
               </span>
            </div>
              <mat-form-field class="fullWidth" appearance="outline">
                <mat-label>{{ 'SearchUser' | translate }}</mat-label>
                <input [disabled]="this.Locked ? true : null || this.Task?.Status?.ID == 1" autocomplete="off" [(ngModel)]="this.SearchTerm" matInput (ngModelChange)="this.searchTermUpdate.next($event)">
                <i class="material-icons SearchUserIcon">search</i>
              </mat-form-field>

              <div class="UsersSearchContainer" *ngIf="this.Users?.length > 0;">
                <div class="UsersSearchRow" *ngFor="let u of this.Users" (click)="AddUserToTask(u);">
                    {{u.UIName}}
                </div>
              </div>

              <div class="AsigneesContainer" *ngIf="this.Task?.Assignees?.length > 0 && this.Task.Locked != true && this.Task.Status.ID != 1;">
                <span class="AsigneeSpan" *ngFor="let a of this.Task?.Assignees" (click)="RemoveUserFromTask(a);">
                    <i class="material-icons">close</i>
                    {{a.UIName}}
                  </span>
              </div>

              <div class="AsigneesContainer" *ngIf="this.Task?.Assignees?.length > 0 && (this.Task.Locked == true || this.Task.Status.ID == 1);">
                <span class="AsigneeSpan" *ngFor="let a of this.Task?.Assignees" style="cursor: not-allowed;">
                    <i class="material-icons" style="color: #aaa;">close</i>
                    {{a.UIName}}
                  </span>
              </div>
        </div>
        <div class="TwoThirdsColumnWithGap" style="padding-right: 50px;margin-bottom: 100px;">
            <div class="ColumnTitle" style="text-transform:capitalize;" *ngIf="this.Task?.ID?.length > 0;">
                <span class="ColumnTitleFancySpan">
                    <i class="material-icons" style="color:#32aa3a;">verified_user</i>
                  {{'TaskID' | translate}}: {{this.Task.ID}}
                </span>
              </div>

              <div class="ColumnTitle" style="text-transform:capitalize;color: #0082e6;">
                <span class="ColumnTitleFancySpan">
                    <i class="material-icons">construction</i>
                  {{'TaskProperties' | translate}}
                </span>
              </div>

              <mat-form-field class="fullWidth" appearance="outline">
                <mat-label>{{ 'Title' | translate }}</mat-label>
                <input [disabled]="this.Locked ? true : null || this.Task?.Status?.ID == 1" autocomplete="off" [(ngModel)]="this.Task.Title" matInput>
              </mat-form-field>

              <mat-form-field appearance="outline" class="fullWidth">
                <mat-label>{{ 'Description' | translate }}</mat-label>
                <textarea [disabled]="this.Locked ? true : null || this.Task?.Status?.ID == 1" autocomplete="off" matInput
                          cdkTextareaAutosize
                          #autosize="cdkTextareaAutosize"
                          cdkAutosizeMinRows="10"
                          cdkAutosizeMaxRows="10"
                          [(ngModel)]="this.Task.Description"></textarea>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>{{ 'MaxExpectedResolveDate' | translate }}</mat-label>
                <input [disabled]="this.Locked ? true : null || this.Task?.Status?.ID == 1" matInput [matDatepicker]="dp" [formControl]="MaxExpectedResolveDate" [(ngModel)]="this.Task.MaxExpectedResolveDate">
                <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                <mat-datepicker #dp></mat-datepicker>
              </mat-form-field>

              <mat-form-field style="width: 100%;" appearance="outline">
                <mat-label>{{ 'TaskSeverity' | translate }}</mat-label>
                <mat-select [disabled]="this.Locked ? true : null || this.Task?.Status?.ID == 1" name="Severity" [compareWith]="this.parent.compareFn" [(ngModel)]="Task.Severity">
                  <mat-option *ngFor="let s of this.SeverityTypes" [value]="s">
                    {{s.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field style="width: 100%;" appearance="outline">
                <mat-label>{{ 'Status' | translate }}</mat-label>
                <mat-select [disabled]="this.Locked ? true : null" name="TaskStatus" [compareWith]="this.parent.compareFn" [(ngModel)]="Task.Status">
                  <mat-option *ngFor="let s of this.InternalTaskStatuses" [value]="s" [disabled]="s.ID == 1" (click)="UpdateInternalTaskStatus();">
                    {{s.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <div class="ColumnTitle" style="text-transform:capitalize;">
                <span class="ColumnTitleFancySpan">
                    <i class="material-icons">messenger</i>
                  {{'TaskComments' | translate}}
                </span>
              </div>

              <div *ngIf="this.Task?.Status?.ID != 1;">
                <button [disabled]="this.Locked ? true : null || this.Task?.Status?.ID == 1" mat-raised-button color="primary" class="MainPrimaryButton" (click)="InitializeNewComment();" *ngIf="this.Comment == null;">
                  <i class="material-icons">add</i>
                  {{'AddComment' | translate}}
                </button>
  
                <button [disabled]="this.Locked ? true : null || this.Task?.Status?.ID == 1" mat-raised-button class="MainCommandButton" *ngIf="this.Comment != null;" style="margin-right: 10px;" (click)="AddNewCommentary();">
                  <i class="material-icons">add</i>
                  {{'AddComment' | translate}}
                </button>
  
              <button [disabled]="this.Locked ? true : null || this.Task?.Status?.ID == 1" style="background: #fd4f57;" mat-raised-button color="primary" class="MainPrimaryButton" (click)="VoidComment();" *ngIf="this.Comment != null;">
                  <i class="material-icons">close</i>
                  {{'CancelComment' | translate}}
              </button>
              </div>

                <mat-form-field appearance="outline" class="fullWidth" *ngIf="this.Comment != null && this.Task?.Status?.ID != 1;">
                <mat-label>{{ 'NewComment' | translate }}</mat-label>
                <textarea [disabled]="this.Locked ? true : null || this.Task?.Status?.ID == 1" autocomplete="off" matInput
                          cdkTextareaAutosize
                          #autosize="cdkTextareaAutosize"
                          cdkAutosizeMinRows="5"
                          cdkAutosizeMaxRows="5"
                          [(ngModel)]="this.Comment.Comment"></textarea>
                </mat-form-field>

                <div class="CommentariesContainer" *ngIf="this.Task?.Comments != null && this.Task?.Comments?.length > 0;">
                    <div class="Commentary" *ngFor="let c of this.Task.Comments">
                        {{c.Comment}}
                        <div class="CommentaryOwner">
                            {{c.Owner.UIName}}
                        </div>
                        <div class="CommentaryTimeStamp">
                            {{c.EventRegisterUI}}
                        </div>
                        <div class="CommentaryDeleteButton unSelectable" (click)="OpenDeleteComment(c);" *ngIf="(this.parent.User.Id == this.Task.Owner.Id || (this.parent.User.Id == c.Owner.Id && this.Task.Locked == false)) && this.Task.Status.ID != 1;">
                            <i class="material-icons">close</i>
                        </div>
                    </div>
                </div>
        </div>
    </div>
    <div class="PageContentBodyCommands" *ngIf="this.InitialLoading != true;">
        <button mat-raised-button class="MainCommandButton" (click)="AddInternalTask();" *ngIf="this.Task.ID == null;">
            <i class="material-icons">add</i>
            {{'AddNewTask' | translate}}
        </button>
        <button [disabled]="this.Locked ? true : null" mat-raised-button class="MainCommandButton" (click)="UpdateInternalTask();" *ngIf="this.Task.ID != null;">
          <i class="material-icons">save_alt</i>
          {{'UpdateTask' | translate}}
        </button>

        <button matTooltip="{{ 'CompleteTaskDescription' | translate }}" matTooltipClass='neutral-tool-tip-management' *ngIf="this.Task.ID == null;" mat-raised-button class="MainCommandButton AddAndFinalizeTaskButton" (click)="AddInternalTask(true);">
          <i class="material-icons" style="color:#32aa3a;">verified</i>
          {{'AddAndCompleteTask' | translate}}
        </button>

        <button matTooltip="{{ 'CompleteTaskDescription' | translate }}" matTooltipClass='neutral-tool-tip-management' *ngIf="this.Task.ID != null && this.Task.Status.ID != this.CompletedStatus.ID;" mat-raised-button class="MainCommandButton AddAndFinalizeTaskButton" (click)="FinalizeTask();">
          <i class="material-icons" style="color:#32aa3a;">verified</i>
          {{'FinalizeTask' | translate}}
        </button>
    </div>
</div>
